import { Modal, Form, Input } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import { MODAL_TYPES } from '../ModalFactory'
import toClass from 'recompose/toClass'

const FormItem = Form.Item
const { TextArea } = Input

function ConfigurationComponent(props) {
  const { form, editingRecord, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal {...rest}>
      <Form layout="vertical">
        <FormItem label="Domain">
          {getFieldDecorator('owner', {
            rules: [
              {
                required: true,
              }
            ]
          })(<Input disabled={props.type == MODAL_TYPES.EditConfiguration} />)}
        </FormItem>
        <FormItem label="Key">
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
              }
            ]
          })(<Input disabled={props.type == MODAL_TYPES.EditConfiguration} />)}
        </FormItem>
        <FormItem label="Value">
          {getFieldDecorator('value', {
            rules: [
              {
                required: true,
              }
            ]
          })(<TextArea rows={7} />)}
        </FormItem>
      </Form>
    </Modal>
  )
}

export const ConfigurationModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(ConfigurationComponent))

ConfigurationComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  editingRecord: PropTypes.object,
  type: PropTypes.string,
}
